import { TFunction, Trans } from 'next-i18next'
import { ArgumentTypes } from 'utils/types'

export function mapKeysToTrans<T extends TFunction>(t: T, keys: ArgumentTypes<T>[0][]) {
  // @ts-ignore
  return keys.map((k, i) => <Trans key={i} t={t} i18nKey={k} />)
}
